export default __webpack_public_path__ + "static/media/ads.ea85a53f.png";